import { useMemo } from 'react';

import { useActionInput } from '../context';
import { actionData } from '../utils/data';

export const useActionData = () => {
	const action = useActionInput();

	return useMemo(() => {
		return actionData(action);
	}, [action]);
};
